// extracted by mini-css-extract-plugin
module.exports = {"userCollection":"index-userCollection-10YBN","handleBar":"index-handleBar-3rl9n"};